import type { ReactNode } from 'react';

/** One line of guidance with a small icon in front. */
export function GuidanceLine({ icon, children }: { icon: ReactNode; children: ReactNode }) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: 7,
        fontSize: 12.5,
        lineHeight: 1.45,
        color: 'var(--nb-ink-2)',
      }}
    >
      <span style={{ marginTop: 2, display: 'flex' }}>{icon}</span>
      <span>{children}</span>
    </div>
  );
}
